module.exports = __webpack_public_path__ + "img/logo-footer-gov.ff72c15a.png";